import { render, staticRenderFns } from "./acceptEditing.vue?vue&type=template&id=6ff18b17"
import script from "./acceptEditing.vue?vue&type=script&lang=js"
export * from "./acceptEditing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports